"use client"

import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"
import { useEffect, useState } from "react"
import { IoIosMenu } from "react-icons/io"
import { BiSolidUserCircle } from "react-icons/bi"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { IoCloseOutline } from "react-icons/io5"
import { MdOutlineKeyboardArrowRight } from "react-icons/md"

function Menu({ menuList, loginData }) {
    const { isLogin, isApprovalWaiting, isInfo } = loginData
    const [isMenuMouseOver, setIsMenuMouseOver] = useState(false)
    const [isMenuDisplayChange, setMenuDisplayChange] = useState(false)
    const [isMenuClick, setMenuClick] = useState(false)
    const [mobileMenuDetail, setMobileMenuDetail] = useState()
    const [activeMenuIndex, setActiveMenuIndex] = useState(-1)
    const [activeSubMenus, setActiveSubMenus] = useState([])
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        const handleWheel = () => {
            setMenuDisplayChange(window.scrollY > 50)
        }

        window.addEventListener("scroll", handleWheel)
        return () => {
            window.removeEventListener("scroll", handleWheel)
        }
    }, [isMenuDisplayChange])

    // 현재 URL에 따라 active 메뉴 설정
    useEffect(() => {
        const currentPath = location.pathname

        // 메인 메뉴 active 설정
        const mainMenuIndex = menuList.findIndex(
            (menu) =>
                menu.url === currentPath || (menu.children && menu.children.some((subMenu) => subMenu.url === currentPath)),
        )

        setActiveMenuIndex(mainMenuIndex)

        // 서브메뉴 active 설정
        if (mainMenuIndex !== -1 && menuList[mainMenuIndex].children) {
            const activeSubMenuUrls = menuList[mainMenuIndex].children
                .filter((subMenu) => subMenu.url === currentPath)
                .map((subMenu) => subMenu.url)

            setActiveSubMenus(activeSubMenuUrls)

            // 모바일에서 현재 페이지에 해당하는 서브메뉴 표시
            if (isMenuClick && mainMenuIndex !== -1) {
                setMobileMenuDetail(menuList[mainMenuIndex].children)
            }
        }
    }, [location.pathname, menuList, isMenuClick])

    const handleMenuMouseOver = () => {
        setIsMenuMouseOver(true)
        setMenuDisplayChange(true)
    }

    const handleMenuMouseLeave = () => {
        setIsMenuMouseOver(false)
        setMenuDisplayChange(window.scrollY > 100)
    }

    const handleMenuClick = () => {
        setMenuClick(true)
        // 현재 active 메뉴의 서브메뉴를 표시
        if (activeMenuIndex !== -1 && menuList[activeMenuIndex]?.children) {
            setMobileMenuDetail(menuList[activeMenuIndex]?.children)
        } else {
            setMobileMenuDetail(menuList[0]?.children)
        }
    }

    const handleMenuClose = () => {
        setMenuClick(false)
        setIsMenuMouseOver(false)
    }

    const handleClick = (url) => {
        navigate(url)
        setTimeout(handleMenuClose, 100)
    }

    const handleSubMenuClick = (event, menu, index) => {
        // 서브메뉴가 없거나 빈 배열인 경우 바로 이동
        if (!menu.children || menu.children.length === 0) {
            handleClick(menu.url)
            return
        }

        // 서브메뉴가 있는 경우 기존 로직 실행
        event.currentTarget.parentElement.childNodes.forEach((child) => child.classList.remove("active"))
        event.currentTarget.classList.add("active")
        setActiveMenuIndex(index)
        setMobileMenuDetail(Array.isArray(menu.children) ? menu.children : [menu.children])
    }

    return (
        <>
            <Mobile>
                <section className="mf-menu">
                    <div className="layout">
                        <div id="menu" className={isMenuDisplayChange ? "background-hover" : "background"}>
                            <div className="icon-area">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/${isMenuDisplayChange ? "logo_b.png" : "logo.png"}`}
                                    onClick={() => handleClick("/")}
                                    alt="logo"
                                />
                            </div>
                            <div className="login-area">
                                {isLogin && isInfo ? (
                                    <BiSolidUserCircle style={{ fontSize: "25px", cursor: "pointer" }} />
                                ) : (
                                    <div style={{ cursor: "pointer" }} onClick={() => handleClick("/login")}>
                                        로그인
                                    </div>
                                )}
                                <IoIosMenu className="menuButton" onClick={handleMenuClick} />
                            </div>
                        </div>
                    </div>

                    <div id="mobile-menu-all-layout" className={isMenuClick ? "menu-all-layout" : "menu-all-layout-hover"}>
                        <div className="background">
                            <div className="menu-header-area">
                                <div className="icon-area">
                                    <img
                                        onClick={() => handleClick("/")}
                                        src={`${process.env.PUBLIC_URL}/images/logo_b.png`}
                                        alt="logo"
                                    />
                                </div>
                                <div className="login-area">
                                    <IoCloseOutline className="menuButton" onClick={handleMenuClose} />
                                </div>
                            </div>

                            <div className="menu-area">
                                <ol id="menu-item" className="menu-item">
                                    {menuList.map((menu, index) => (
                                        <li
                                            key={index}
                                            onClick={(event) => handleSubMenuClick(event, menu, index)}
                                            className={index === activeMenuIndex ? "active" : ""}
                                        >
                                            {menu.name} <MdOutlineKeyboardArrowRight />
                                        </li>
                                    ))}
                                </ol>
                                <ul className="menu-sub-item">
                                    {mobileMenuDetail?.map((subMenu, index) => (
                                        <li
                                            key={index}
                                            onClick={() => handleClick(subMenu.url)}
                                            className={activeSubMenus.includes(subMenu.url) ? "active" : ""}
                                        >
                                            {subMenu.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </Mobile>

            <Tablet>
                <section className="mf-menu">
                    <div className="layout">
                        <div id="menu" className={isMenuDisplayChange ? "background-hover" : "background"}>
                            <div className="icon-area">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/${isMenuDisplayChange ? "logo_b.png" : "logo.png"}`}
                                    onClick={() => handleClick("/")}
                                    alt="logo"
                                />
                            </div>
                            <div className="login-area">
                                {isLogin && isInfo ? (
                                    <BiSolidUserCircle style={{ fontSize: "25px", cursor: "pointer" }} />
                                ) : (
                                    <div style={{ cursor: "pointer" }} onClick={() => handleClick("/login")}>
                                        로그인
                                    </div>
                                )}
                                <IoIosMenu className="menuButton" onClick={handleMenuClick} />
                            </div>
                        </div>
                    </div>

                    <div id="menu-all-layout" className={isMenuClick ? "menu-all-layout" : "menu-all-layout-hover"}>
                        <div className="background">
                            <div className="menu-header-area">
                                <div className="icon-area">
                                    <img
                                        onClick={() => handleClick("/")}
                                        src={`${process.env.PUBLIC_URL}/images/logo_b.png`}
                                        alt="logo"
                                    />
                                </div>
                                <div className="login-area">
                                    <IoCloseOutline className="menuButton" onClick={handleMenuClose} />
                                </div>
                            </div>

                            <div className="menu-area">
                                <ol id="menu-item" className="menu-item">
                                    {menuList.map((menu, index) => (
                                        <li
                                            key={index}
                                            onClick={(event) => handleSubMenuClick(event, menu, index)}
                                            className={index === activeMenuIndex ? "active" : ""}
                                        >
                                            {menu.name} <MdOutlineKeyboardArrowRight />
                                        </li>
                                    ))}
                                </ol>
                                <ul className="menu-sub-item">
                                    {mobileMenuDetail?.map((subMenu, index) => (
                                        <li
                                            key={index}
                                            onClick={() => handleClick(subMenu.url)}
                                            className={activeSubMenus.includes(subMenu.url) ? "active" : ""}
                                        >
                                            {subMenu.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </Tablet>

            <Notebook>
                <section className="nf-menu">
                    <div className="layout">
                        <div
                            id="menu"
                            className={isMenuDisplayChange ? "background-hover" : "background"}
                            onMouseEnter={handleMenuMouseOver}
                            onMouseLeave={handleMenuMouseLeave}
                        >
                            <div className="icon-area">
                                <Link to="/">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/${isMenuDisplayChange ? "logo_b.png" : "logo.png"}`}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                            <div className="menu-area">
                                <ol>
                                    {menuList.map((menu, index) => (
                                        <li
                                            key={index}
                                            onMouseEnter={handleMenuMouseOver}
                                            onClick={() => handleClick(menu.url)}
                                            className={index === activeMenuIndex ? "active" : ""}
                                        >
                                            {menu.name}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            <div className="login-area">
                                {isLogin && isInfo ? (
                                    <BiSolidUserCircle style={{ fontSize: "25px", cursor: "pointer" }} />
                                ) : (
                                    <div style={{ cursor: "pointer" }} onClick={() => handleClick("/login")}>
                                        로그인
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="menu-all-layout" onMouseEnter={handleMenuMouseOver} onMouseLeave={handleMenuMouseLeave}>
                        <div className={`background ${isMenuMouseOver ? "show" : ""}`}>
                            <div className="menu-all">
                                <div className="center-area">
                                    {menuList.map((menuL, xIndex) => (
                                        <ul key={xIndex}>
                                            {menuL?.children.map((subMenu, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => handleClick(subMenu?.url)}
                                                    className={activeSubMenus.includes(subMenu.url) ? "active" : ""}
                                                >
                                                    {subMenu?.name}
                                                </li>
                                            ))}
                                        </ul>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Notebook>

            <PC>
                <section className="pf-menu">
                    <div className="layout">
                        <div
                            id="menu"
                            className={isMenuDisplayChange ? "background-hover" : "background"}
                            onMouseEnter={handleMenuMouseOver}
                            onMouseLeave={handleMenuMouseLeave}
                        >
                            <div className="icon-area">
                                <Link to="/">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/${isMenuDisplayChange ? "logo_b.png" : "logo.png"}`}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                            <div className="menu-area">
                                <ol>
                                    {menuList.map((menu, index) => (
                                        <li
                                            key={index}
                                            onMouseEnter={handleMenuMouseOver}
                                            onClick={() => handleClick(menu.url)}
                                            className={index === activeMenuIndex ? "active" : ""}
                                        >
                                            {menu.name}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            <div className="login-area">
                                {isLogin && isInfo ? (
                                    <BiSolidUserCircle style={{ fontSize: "25px", cursor: "pointer" }} />
                                ) : (
                                    <div style={{ cursor: "pointer" }} onClick={() => handleClick("/login")}>
                                        로그인
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="menu-all-layout" onMouseEnter={handleMenuMouseOver} onMouseLeave={handleMenuMouseLeave}>
                        <div className={`background ${isMenuMouseOver ? "show" : ""}`}>
                            <div className="menu-all">
                                <div className="center-area">
                                    {menuList.map((menuL, xIndex) => (
                                        <ul key={xIndex}>
                                            {menuL?.children.map((subMenu, index) => (
                                                <li
                                                    key={index}
                                                    onClick={() => handleClick(subMenu?.url)}
                                                    className={activeSubMenus.includes(subMenu.url) ? "active" : ""}
                                                >
                                                    {subMenu?.name}
                                                </li>
                                            ))}
                                        </ul>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </PC>
        </>
    )
}

export default Menu
